import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from 'src/environments/environment';

const noop = () => { };

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CbTextareaComponent),
  multi: true,
};

@Component({
  selector: 'cb-textarea',
  templateUrl: './cb-textarea.component.html',
  styleUrls: ['./cb-textarea.component.scss', '../cb-form-style.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class CbTextareaComponent implements ControlValueAccessor, OnInit {
  @Input() public placeholder?: string = '';
  @Input() public label?: string = '';
  @Input() public autofocus?: boolean;
  @Input() public rows = 1;
  @Input() public maxRows ?:number;
  @Input() public disabled = false;
  @Input() public error = false;

  @Output('input') public onInput: EventEmitter<string> =
    new EventEmitter<string>();
  @Output('change') public onChange: EventEmitter<string> =
    new EventEmitter<string>();

  @ViewChild('textarea') private inputRef?: ElementRef;

  //The internal data model
  private innerValue = '';

  public lastCaretPosition = 0;

  constructor(private readonly cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.autofocus) this.focusInput();
  }

  ngAfterViewInit(): void {
    this.setInputListener();
  }

  private setInputListener(): void { }

  // Placeholders for the callbacks which are later provided
  // by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  // get accessor
  public get value(): string {
    return this.innerValue;
  }

  // Set accessor including call the onchange callback
  public set value(v: string) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  public updateCaretPosition(): void {
    this.lastCaretPosition = this.inputRef?.nativeElement.selectionStart;
  }

  // From ControlValueAccessor interface
  public writeValue(value: any) {
    if (!value && environment.inputCompiled) {
      this.onChangeCallback(this.innerValue);
      this.cdr.detectChanges();
    }
    else {
      if (value !== this.innerValue) {
        this.innerValue = value;
        this.onChangeCallback(this.innerValue);
        this.cdr.detectChanges();

      }
    }
  }

  public input(): void {
    this.updateCaretPosition();
    this.onInput.emit(this.value);
  }
  public change(): void {
    this.onChange.emit(this.value);
  }

  // From ControlValueAccessor interface
  public registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  public registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  public focusInput(): void {
    setTimeout(() => {
      this.inputRef?.nativeElement.focus();
    }, 0);
  }
  
}
